"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageLoadingOptions = void 0;
var ImageLoadingOptions = (function () {
    function ImageLoadingOptions(calculateActualSize, actualSize, callback) {
        if (calculateActualSize === void 0) { calculateActualSize = false; }
        this.imageLoadedEvent = [];
        this.calculateActualSize = calculateActualSize;
        this.actualSize = actualSize;
        if (callback)
            this.imageLoadedEvent.push(callback);
    }
    ImageLoadingOptions.initByActualSize = function (actualSize, callback) {
        actualSize = actualSize && actualSize.width && actualSize.height ? actualSize : undefined;
        return new ImageLoadingOptions(!actualSize, actualSize, callback);
    };
    return ImageLoadingOptions;
}());
exports.ImageLoadingOptions = ImageLoadingOptions;
